import { siteTexts } from "../../../../shared/i18n/siteTexts";
import type { AdminEventRegistration } from "../../../admin/services/eventRegistrationAdminService";

export function formatRegistrationStatusLabel(
  status: AdminEventRegistration["status"],
) {
  if (status === "confirmed")
    return siteTexts.admin.registrationsTab.statusFilters.confirmed;
  if (status === "waitlist")
    return siteTexts.admin.registrationsTab.statusFilters.waitlist;
  if (status === "canceled")
    return siteTexts.admin.registrationsTab.statusFilters.canceled;
  return siteTexts.admin.registrationsTab.statusFilters.pending;
}

export function formatPaymentStatusLabel(
  status: AdminEventRegistration["paymentStatus"],
) {
  if (status === "confirmed")
    return siteTexts.challenges.publicDetail.registration.statuses.confirmed;
  if (status === "canceled")
    return siteTexts.admin.registrationsTab.statusFilters.canceled;
  if (status === "refunded")
    return siteTexts.challenges.publicDetail.registration.statuses.refunded;
  return siteTexts.admin.registrationsTab.statusFilters.pending;
}

export function formatRegistrationShirtSizes(
  registration: AdminEventRegistration,
) {
  const playerSize = String(registration.shirtSizes?.player || "").trim();
  const partnerSize = String(registration.shirtSizes?.partner || "").trim();
  if (!playerSize && !partnerSize) return "";
  const playerName = String(registration.userName || "Titular").trim();
  const partnerName = String(registration.partnerName || "Dupla").trim();
  return [
    playerSize ? `${playerName}: ${playerSize}` : "",
    partnerSize ? `${partnerName}: ${partnerSize}` : "",
  ]
    .filter(Boolean)
    .join(" · ");
}

export function isManualAdminRegistration(
  registration: AdminEventRegistration,
) {
  const provider = String(registration.paymentProvider || "")
    .trim()
    .toLowerCase();
  const reference = String(registration.paymentReference || "")
    .trim()
    .toLowerCase();
  const note = String(registration.adminNote || "")
    .trim()
    .toLowerCase();
  return (
    provider === "manual" ||
    reference.includes("manual-admin") ||
    note.includes("manual")
  );
}

export function canShowGeneratePaymentLink(
  registration: AdminEventRegistration,
) {
  if (registration.status === "canceled") return false;
  if (registration.paymentStatus === "confirmed") return false;
  if (registration.paymentStatus === "pending") return true;
  return isManualAdminRegistration(registration);
}

export function registrationPriorityScore(
  registration: AdminEventRegistration,
) {
  const paymentStatus = String(registration.paymentStatus || "")
    .trim()
    .toLowerCase();
  const status = String(registration.status || "")
    .trim()
    .toLowerCase();
  let score = 0;
  if (paymentStatus === "confirmed") score += 1000;
  if (paymentStatus === "pending") score += 100;
  if (status === "confirmed") score += 50;
  if (status === "pending") score += 20;
  if (status === "waitlist") score += 10;
  const updatedAtMs = Date.parse(String(registration.updatedAt || ""));
  const createdAtMs = Date.parse(String(registration.createdAt || ""));
  const timeScore = Number.isFinite(updatedAtMs)
    ? updatedAtMs
    : Number.isFinite(createdAtMs)
      ? createdAtMs
      : 0;
  return score * 1_000_000_000 + timeScore + Number(registration.id || 0);
}

export function pickPreferredRegistration(
  current: AdminEventRegistration | undefined,
  candidate: AdminEventRegistration,
) {
  if (!current) return candidate;
  return registrationPriorityScore(candidate) >
    registrationPriorityScore(current)
    ? candidate
    : current;
}
